import React from "react";

function ExportReportSupportAll({ tickets, userHead }) {
  let rank = 0;

  return (
    <div className="p-5">
      <div className="d-flex justify-content-between">
        <img width="100px" src="/logo.png" />
        <div className="text-center">
          <h6 className="mb-0">FIGARO COFFEE SYSTEM, INC.</h6>
          <h6 className="mb-0">Summary Report By Date Range</h6>
        </div>
        <img width="100px" src="/logo.png" />
      </div>
      <table className="table table-striped mt-3">
        <thead>
          <tr className="text-center">
            <th>Ticket #</th>
            <th>Department</th>
            <th>Head</th>
            <th>User</th>
            <th>Date Report</th>
            <th>Date Close</th>
            <th>Range</th>
          </tr>
        </thead>
        <tbody>
          {tickets.map((ticket, index) => {
            const { department, creator, createdAt, date_closed, id } = ticket;
            const departmentName = department?.name || "N/A";
            const head = department?.head || "N/A"; // Assuming 'head' is available in the department object
            const user = creator?.name || "N/A";
            const dateReport = new Date(createdAt).toLocaleString();
            const dateClose = date_closed
              ? new Date(date_closed).toLocaleString()
              : "N/A";

            // console.log("DateClosed", date_closed);
            // console.log("created", createdAt);

            // Calculate the range from created to closed date
            // const range =
            //   createdAt && date_closed
            //     ? `${Math.floor(
            //         (new Date(date_closed) - new Date(createdAt)) /
            //           (1000 * 60 * 60 * 24)
            //       )} days`
            //     : "N/A";
            // Usage:
            const range =
              createdAt && date_closed
                ? formatDiff(createdAt, date_closed) // e.g., "2 days 3 hours 15 minutes"
                : "N/A";

            // Helper:
            function formatDiff(
              start,
              end,
              { includeSeconds = false, showZeroUnits = false } = {}
            ) {
              const diffMs = new Date(end) - new Date(start);
              if (!isFinite(diffMs)) return "N/A";

              const sign = diffMs < 0 ? -1 : 1;
              let ms = Math.abs(diffMs);

              const DAY = 24 * 60 * 60 * 1000;
              const HOUR = 60 * 60 * 1000;
              const MIN = 60 * 1000;

              const days = Math.floor(ms / DAY);
              ms %= DAY;
              const hours = Math.floor(ms / HOUR);
              ms %= HOUR;
              const mins = Math.floor(ms / MIN);
              ms %= MIN;
              const secs = Math.floor(ms / 1000);

              const parts = [];
              const push = (v, label) => {
                if (showZeroUnits || v)
                  parts.push(`${v} ${label}${v === 1 ? "" : "s"}`);
              };

              push(days, "day");
              push(hours, "hour");
              push(mins, "minute");
              if (includeSeconds) push(secs, "second");

              const text = parts.length
                ? parts.join(" ")
                : includeSeconds
                ? "0 seconds"
                : "0 minutes";
              return sign < 0 ? `-${text}` : text;
            }

            // Increment rank
            rank++;

            // console.log("range", range);

            return (
              <tr className="text-center" key={ticket.id}>
                <td>{id}</td>
                <td>{departmentName}</td>
                <td>{userHead.name}</td>
                <td>{user}</td>
                <td>{dateReport}</td>
                <td>{dateClose}</td>
                <td>{range}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ExportReportSupportAll;
